import { enToggleScanner } from './types'

export const toggleScanner = (value: boolean) => ({
  type: enToggleScanner.TOGGLE,
  value,
})
